import React, { Component } from 'react';
import { connect } from 'react-redux';
import SimpleTable from 'components/shared/table/SimpleTable';
import './WorkOrderAuthorizations.css';
import DocumentLink from 'components/shared/document/DocumentLink';
import SigningModal from 'components/shared/modal/SigningModal';
import {
  showSignWoaModal,
  hideWoaSigningModal,
} from 'actions/admin/work-orders/details/details';
import {
  getWoaSigningUrl,
  getShowWoaSigningModal,
  getWorkOrderAuthorizations,
} from 'selectors/admin/work-orders/details/details';
import { getCurrentUser } from 'selectors/authentication';
import { usersUtil, TYPES } from 'services/utils/users-util';

class WorkOrderAuthorizations extends Component {
  constructor(props) {
    super(props);

    this.userIsContractor = usersUtil.hasType(
      props.currentUser,
      TYPES.CONTRACTOR
    );
  }

  mapWoas = (woas) => {
    return woas.map((woa) => {
      return [
        woa.number,
        !this.userIsContractor && woa.contractor.name,
        woa.document ? <DocumentLink url={woa.document.document.url} /> : 'N/A',
        !woa.document && (
          <input
            type="button"
            className="btn button button-orange"
            value="Sign WOA"
            onClick={() => this.handleSignWoa(woa.id)}
          />
        ),
      ].filter((item) => !!item);
    });
  };

  handleSignWoa = (woaId) => {
    this.props.dispatch(showSignWoaModal(woaId));
  };

  handleWoaSigningModalClose = () => {
    this.props.dispatch(hideWoaSigningModal());
  };

  render() {
    const headers = [
      'NUMBER',
      !this.userIsContractor && 'CONTRACOTR',
      'DOC LINK',
      ' ', // button
    ].filter((item) => !!item);

    return (
      <div className="work-order-authorizations">
        <SimpleTable
          className={`work-order-authorizations-table ${
            this.userIsContractor && 'for-contractor'
          }`}
          headers={headers}
          rows={this.mapWoas(this.props.workOrderAuthorizations)}
          emptyMessage="No Work Order Authorizations"
        />
        <SigningModal
          show={this.props.showWoaSigningModal}
          url={this.props.woaSigningUrl}
          title="Sign WOA"
          handleClose={this.handleWoaSigningModalClose}
        />
      </div>
    );
  }
}

export default connect((state) => {
  return {
    woaSigningUrl: getWoaSigningUrl(state),
    showWoaSigningModal: getShowWoaSigningModal(state),
    workOrderAuthorizations: getWorkOrderAuthorizations(state),
    currentUser: getCurrentUser(state),
  };
})(WorkOrderAuthorizations);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/work-order-authorizations/WorkOrderAuthorizations.js